import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY } from './useFetchAllianceApplications';
import { AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY } from './useFetchAgentAllianceApplicationDetail';

interface UpdateMemoParams {
  id: string;
  internalMemo: string;
}

export default function useUpdateAgentAllianceApplicationMemo() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, internalMemo }: UpdateMemoParams) => {
      const response = await fetch(`/agent/api/alliance_applications/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ alliance_application: { internal_memo: internalMemo } }),
      });

      if (!response.ok) {
        let errorMessage = '社内メモの更新に失敗しました';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY });
    },
  });
}
